//import { findIana } from "windows-iana";
import { useEffect, useState } from "react";
//import { QUERY_KEYS, customerInfoEndPoint, useDataHook } from "../../api";

type CustomerInfoType = {
  timeZone: string;
  country: string;
  language: string;
};

export const useCustomer = () => {
  const defaultWindowsTimeZone = "Romance Standard Time";
  const defaultIanaTimeZone = "Europe/Copenhagen";

  const convertToIanaTimezone = (windowsTimezone: string): string => {
    //const windowsTimeZone = windowsTimezone || defaultWindowsTimeZone;
    //return findIana(windowsTimeZone)[0] || defaultIanaTimeZone;
    return defaultIanaTimeZone;
  };

  /*const request = useDataHook<CustomerInfoType>(
    QUERY_KEYS.CUSTOMER_INFO,
    "fetchCustomerInfo",
    customerInfoEndPoint
  );*/

  const [timezone, setTimezone] = useState<string>();

  /*useEffect(() => {
    if (!request.isFetching && !request.isLoading && (request.isError || request.data?.timeZone)) {
      setTimezone(
        convertToIanaTimezone(
          !request.isError && request.data?.timeZone
            ? request.data.timeZone
            : defaultWindowsTimeZone
        )
      );
    }
  }, [request]);*/

  return defaultWindowsTimeZone;
};
